import { useEffect } from 'react';
import { useRouteError } from 'react-router';

import { instrumentation } from '@/instrument';

import { Button } from '../ui/button';

/**
 * React Router v7 Error Boundary Component
 * This is rendered when a route throws an error or loader/action fails
 *
 * Note: This receives error from useRouteError(), not as a prop
 */
export const AuthFallback = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      instrumentation.captureException(error as Error, {
        componentStack: 'AuthFallback',
      });
    }
  }, [error]);

  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center text-red-500"
      role="alert"
    >
      <h2 className="text-lg font-semibold">Ooops, something went wrong :( </h2>
      <Button
        className="mt-4"
        onClick={() => globalThis.location.assign(globalThis.location.origin)}
      >
        Refresh
      </Button>
    </div>
  );
};
